interface AvatarPreviewProps {
  file: string | File | null;
}

export default function AvatarPreview({ file }: AvatarPreviewProps) {
  if (!file) return null;

  const imgUrl = typeof file === 'string' ? file : URL.createObjectURL(file);

  return <img alt="avatar" src={imgUrl} className="h-full w-full object-cover" />;
}
